import React, { createContext, useContext } from "react";
import { ActivatedParams, FiltersState, useFiltersMap } from "./useFiltersMap";

interface ProviderValue<T> {
  activeFilters: FiltersState<T>;
  activateFilter(params: ActivatedParams<T>): void;
  activateFilters(filters: FiltersState<T>): void;
  deactivateFilter(filterId: string): void;
  clearActivated(): void;
  updatePersistent(filters: FiltersState<T>): void;
}

const ListFilterContext = createContext<ProviderValue<any> | undefined>(undefined);
ListFilterContext.displayName = "ListFilterContext"; // for name to display in dev tools

export const SettingsListFilterProvider = <T extends unknown>({
  children
}: React.PropsWithChildren<{}>) => {
  const filtersHook = useFiltersMap({});

  const value: ProviderValue<T> = {
    activeFilters: filtersHook.filters,
    activateFilter: filtersHook.activateFilter,
    activateFilters: filtersHook.activateFilters,
    deactivateFilter: filtersHook.deactivateFilter,
    clearActivated: filtersHook.clearFilters,
    updatePersistent: filtersHook.updatePersistent
  };

  return <ListFilterContext.Provider value={value}>{children}</ListFilterContext.Provider>;
};

export const useSettingsListFilters = <T extends unknown>(): ProviderValue<T> => {
  const context = useContext(ListFilterContext);

  if (context === undefined) {
    throw new Error("useListFilters must be used within a ListFilterProvider");
  }

  return context as ProviderValue<T>;
};
